import {get} from 'lodash';
import {logout} from './auth';
import axios from "axios/index";


export const getMappingUtil = (code, stateName, req, suc, error) => (dispatch, getState) => {
    const {selectedType} = getState()[stateName];
    dispatch(req(code));
    return axios.get(`/lov/mapping/${selectedType}/${code}`, getConfig(getState))
        .then(res => { console.log('LOV MAPPINGS', res); return res;})
        .then(res => dispatch(suc(res.data, code)))
        .catch(err => dispatch(error(err)))
};

export const getConfig = (getState) => {
    const token = getState().auth.token;
    if (!token) console.error("Token is missing!");
    return {headers: {"Authorization": 'Bearer ' + token}}
};

/**
 *
 * @param {function} dispatch
 * @param {function} action
 * @return {function(error): *}
 */
export const evalError = (dispatch, action) => error => {
    const err = get(error, 'response.data', error);
    if (err.type === "TokenExpiredException") dispatch(logout());
    return action && dispatch(action(err));
};




// WEBPACK FOOTER //
// ./src/js/reducers/utility.js